import api from ".";
import cookiesModifier from "../utils/cookies";

import { ICategory } from "../types/category";

export const getAllCategories = async () => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.get(`categories`);

        return res.data as ICategory[];
    } catch (error) {
        throw error;
    }
}

export const createCategory = async (data: ICategory) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.post('categories', data);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const updateCategory = async (data: ICategory) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.patch(`categories/${data.id}`, data);
        return res.status;
    } catch (error) {
        throw error;
    }
}


export const deleteCategory = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.delete(`categories/${id}`);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const updateCategoryOrder = async (id: number, action: 'up' | 'down') => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.patch(`categories/order/${id}/${action}`);
        return res.status;
    } catch (error) {
        throw error;
    }
};

export const duplicateCategory = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.post(`categories/duplicate/${id}`);
        return res.data;
    } catch (error) {
        throw error;
    }
}